module.exports = __webpack_public_path__ + "img/autoamerics-original-480.977160c6.png";